import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import useAuthStore from './store/authStore';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Warehouses from './pages/Warehouses';
import RawMaterials from './pages/RawMaterials';
import FinishedGoods from './pages/FinishedGoods';
import Production from './pages/Production';
import Sales from './pages/Sales';
import LadingBills from './pages/LadingBills';
import Transfers from './pages/Transfers';
import Reports from './pages/Reports';
import Users from './pages/Users';
import AuditLog from './pages/AuditLog';
import Inventory from './pages/Inventory';
import Purchases from './pages/Purchases';
import Accounting from './pages/Accounting';
import Chat from './pages/Chat';

function PrivateRoute({ children }) {
  const { token } = useAuthStore();
  return token ? children : <Navigate to="/login" replace />;
}

function AdminRoute({ children }) {
  const { user } = useAuthStore();
  return user?.role === 'admin' ? children : <Navigate to="/" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" toastOptions={{ style: { background: '#0c1020', color: '#f1f3ff', border: '1px solid rgba(255,255,255,0.1)', fontSize: '13px', fontFamily: 'Vazirmatn Variable, Inter Variable, sans-serif' } }} />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="warehouses" element={<Warehouses />} />
          <Route path="raw-materials" element={<RawMaterials />} />
          <Route path="finished-goods" element={<FinishedGoods />} />
          <Route path="production" element={<Production />} />
          <Route path="sales" element={<Sales />} />
          <Route path="lading-bills" element={<LadingBills />} />
          <Route path="transfers" element={<Transfers />} />
          <Route path="inventory" element={<Inventory />} />
          <Route path="purchases" element={<Purchases />} />
          <Route path="accounting" element={<Accounting />} />
          <Route path="chat" element={<Chat />} />
          <Route path="reports" element={<Reports />} />
          <Route path="users" element={<AdminRoute><Users /></AdminRoute>} />
          <Route path="audit-log" element={<AdminRoute><AuditLog /></AdminRoute>} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
